import {
  Alert,
  AppState,
  Image,
  ImageBackground,
  Linking,
  NativeEventSubscription,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useCallback, useEffect, useState } from "react";
import { AppIcons } from "../../assets/images";
import FastImage from "react-native-fast-image";
import { AppTheme } from "../../utils/theme";
import Spacer from "../../components/global/Spacer";
import {
  useFocusEffect,
  useIsFocused,
  useNavigation,
} from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { ROUTE_NAME } from "../../utils/routes";
import { useAppSelector } from "../../redux/storeHook"; // Updated: Added useAppDispatch
import SettingsModal from "../../components/SettingModal";
import {
  DELETE_ACCOUNT_OTP,
  DELETE_ACCOUNT_REUQUST,
  formatCoins,
  GAME_CONFIG,
  GET_USER_DETAIL,
  getFCmToken,
  getParams,
  interstitial,
  LOGOUT,
  PRIVACY_POLICY,
  TERMS_WITH_CONDITIONS,
  truncateText,
  UPDATE_APP_VERSION,
  UPDATE_USER_STATUS,
} from "../../utils/contants";
import api from "../../utils/axiosinstance";
import { userAction } from "../../redux/reducers/user";
import axios from "axios";
import PrivacyWithTerms from "../../components/PrivacyWithTerms";
import { AdEventType } from "react-native-google-mobile-ads";
import DeviceInfo from "react-native-device-info";
import { showToastNotification } from "../../components/global/Toast";

const HomeScreen = () => {
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const isFocused = useIsFocused();
  const { userData } = useAppSelector((s) => s.user);
  const [showSettings, setShowSettings] = useState(false);
  const [music, setMusic] = useState<boolean>(true);
  const [sound, setSound] = useState<boolean>(true);
  const [notifications, setNotifications] = useState<boolean>(false);
  const [motivation, setMotivation] = useState<boolean>(true);
  const [termsModal, setTermsModal] = useState<boolean>(false);
  const [privacyModal, setPrivacyModal] = useState<boolean>(false);
  const [isdeleted, setIsdeleted] = useState<boolean>(false);
  const [otpDeleted, setOtpDeleted] = useState<string>("");

  const [generateOtpLoading, setGenerateOtpLoading] = useState<boolean>(false);

  const { isSoundOn, isMusicOn, isPlayMusicOn } = useAppSelector(
    (state) => state.user,
  );

  useEffect(() => {
    if (userData?.access_token) {
      getUserProfileData();
    }
  }, [isFocused]);

  useEffect(() => {
    if (AppState.currentState == "active") {
      updateUserStatus(true);
    } else if (
      AppState.currentState == "inactive" ||
      AppState.currentState == "unknown"
    ) {
      updateUserStatus(false);
    }
  }, [AppState]);

  // useEffect(() => {
  //   if (userData?.access_token) {
  //     fetchGameConfig();
  //     updateAppVersion();
  //   }
  //   const unsubscribeLoaded = interstitial.addAdEventListener(
  //     AdEventType.LOADED,
  //     () => {
  //       console.log("@ interstitial ad loaded");
  //     },
  //   );
  //   const unsubscribeOpened = interstitial.addAdEventListener(
  //     AdEventType.OPENED,
  //     () => {
  //       console.log("@ interstitial ad opened");
  //     },
  //   );
  //   const unsubscribeClosed = interstitial.addAdEventListener(
  //     AdEventType.CLOSED,
  //     () => {
  //       console.log("@ interstitial ad closed");
  //     },
  //   );
  //   // interstitial.load();
  //   return () => {
  //     unsubscribeLoaded();
  //     unsubscribeOpened();
  //     unsubscribeClosed();
  //   };
  // }, []);

  useEffect(() => {
    console.log("@ isSoundOn value in home screen: ", isSoundOn);
    fetchSound();
    fetchMusic();
  }, [isSoundOn, isMusicOn]);

  const fetchSound = async () => {
    if (isMusicOn && isPlayMusicOn) {
      setMusic(true);
    } else {
      setMusic(false);
    }
  };

  const fetchMusic = async () => {
    if (isSoundOn) {
      setSound(true);
    } else {
      setSound(false);
    }
  };

  const updateAppVersion = async () => {
    try {
      const version = DeviceInfo.getVersion();
      const body = {
        appVersion: version,
      };
      const res = await api.patch(UPDATE_APP_VERSION, body);
      console.log("@ res for game configupdateAppVersion : ", res.data);
    } catch (err) {
      console.log("@ err in logout : ", err);
      if (axios.isAxiosError(err) && err.response) {
        console.log("Response error:", err.response.data);
        showToastNotification(
          "",
          err.response?.data?.message || "An unexpected error occurred",
        );
      } else {
        console.log("Unexpected error:", err);
        showToastNotification("", "An unexpected error occurred");
      }
      console.log("@ err in fetching updateAppVersion : ", err);
    }
  };

  const deleteAccountRequest = async () => {
    try {
      const body = {
        email: userData.email,
      };
      setGenerateOtpLoading(true);
      console.log(" delete account : ", body);
      const res = await api.post(DELETE_ACCOUNT_REUQUST, body);
      if (res.data?.status) {
        console.log("  delete account api response : ", res.data.status);
        showToastNotification("", res.data?.message);
        setIsdeleted(true);
        setGenerateOtpLoading(false);
      }
    } catch (err) {
      setGenerateOtpLoading(false);
      if (axios.isAxiosError(err) && err.response) {
        console.log("Response error:", err.response.data);
        showToastNotification(
          "",
          err.response?.data?.message || "An unexpected error occurred",
        );
      } else {
        console.log("Unexpected error:", err);
        showToastNotification("", "An unexpected error occurred");
      }
      console.log("@ err in completeLesson : ", err);
    }
  };

  const deleteAccount = async (fullOtp: string) => {
    try {
      const body = {
        email: userData.email,
        otp: fullOtp,
      };
      userAction.setTouchSound(true);
      setGenerateOtpLoading(true);
      const res = await api.post(DELETE_ACCOUNT_OTP, body);
      if (res.data?.status) {
        // console.log("  delete account api response : ", res.data.status);
        showToastNotification("", res.data?.message);
        setGenerateOtpLoading(false);
        setShowSettings(false);
        setIsdeleted(false);
        userAction.logoutUser();
      }
    } catch (err) {
      setGenerateOtpLoading(false);
      if (axios.isAxiosError(err) && err.response) {
        console.log("Response error:", err.response.data);
        showToastNotification(
          "",
          err.response?.data?.message || "An unexpected error occurred",
        );
      } else {
        console.log("Unexpected error:", err);
        showToastNotification("", "An unexpected error occurred");
      }
      console.log("@ err in completeLesson : ", err);
    }
  };

  const getUserProfileData = async () => {
    try {
      const res = await api.get(GET_USER_DETAIL);
      console.log("@ res for getUserPRofiledata : ", res.data);
      if (res.data.status) {
        userAction.updateUserField({
          key: "matchStats",
          value: res.data?.user?.matchStats,
        });
        userAction.updateUserField({
          key: "coins",
          value: res.data?.user?.coins,
        });
        userAction.updateUserField({
          key: "level",
          value: res.data?.user?.level,
        });
      }
    } catch (err) {
      console.log("@ err in logout : ", err);
      if (axios.isAxiosError(err) && err.response) {
        console.log("Response error:", err.response.data);
        showToastNotification(
          "",
          err.response?.data?.message || "An unexpected error occurred",
        );
      } else {
        console.log("Unexpected error:", err);
        showToastNotification("", "An unexpected error occurred");
      }
      console.log("@ err in fetching getUserProfileData : ", err);
    }
  };

  const fetchGameConfig = async () => {
    try {
      const res = await api.get(GAME_CONFIG);
      console.log("@ res for game config : ", res.data);
      if (res.data.status) {
        userAction.updateUserField({
          key: "allowedEntryFees",
          value: res.data?.data?.allowedEntryFees[0] || 100,
        });
      }
    } catch (err) {
      console.log("@ err in logout : ", err);
      if (axios.isAxiosError(err) && err.response) {
        console.log("Response error:", err.response.data);
        showToastNotification(
          "",
          err.response?.data?.message || "An unexpected error occurred",
        );
      } else {
        console.log("Unexpected error:", err);
        showToastNotification("", "An unexpected error occurred");
      }
      console.log("@ err in fetching gmae config : ", err);
    }
  };

  const logoutUser = async () => {
    try {
      const token = await getFCmToken();
      let res;
      try {
        res = await api.post(LOGOUT, {
          device_token: token,
        });
      } catch (e) {
        console.log("@ backend logout response/ignored:", e);
      }
      setShowSettings(false);
      userAction.logoutUser();
      showToastNotification("", res?.data?.message || "Logged out successfully");
    } catch (err) {
      console.log("@ err in logout : ", err);
      setShowSettings(false);
      userAction.logoutUser();
      showToastNotification("", "Logged out successfully");
    }
  };

  const updateUserStatus = async (status: boolean) => {
    try {
      if (!userData?.access_token) {
        return;
      }
      const res = await api.post(UPDATE_USER_STATUS, {
        isOnline: status,
      });
      console.log("@ rs for updateuserstatus : ", res.data);
    } catch (err) {
      console.log("@ err in updateUserStatus : ", err);
      if (axios.isAxiosError(err) && err.response) {
        console.log("Response error:", err.response.data);
        showToastNotification(
          "",
          err.response?.data?.message || "An unexpected error occurred",
        );
      } else {
        console.log("Unexpected error:", err);
        showToastNotification("", "An unexpected error occurred");
      }
      console.log("@ err in updateUserStatus : ", err);
    }
  };

  const confirmLogout = () => {
    Alert.alert("Confirm Logout", "Are you sure you want to logout?", [
      {
        text: "Cancel",
        style: "cancel",
      },
      {
        text: "Logout",
        style: "destructive",
        onPress: () => logoutUser(), // call your API logout
      },
    ]);
  };

  // Helper to handle touch sound + navigation (reusable for single-tap play)
  const handlePlayPress = (route: string, params?: any) => {
    userAction.setTouchSound(true); // Trigger touch sound on every tap
    // setTimeout(() => {
    //   if (interstitial.loaded) {
    //     interstitial.show();
    //     // setAdLoaded(false);
    //   } else {
    //     interstitial.load();
    //   }
    //   navigation.navigate(route, params);
    // }, 200);
    navigation.navigate(route, params);
  };

  return (
    <ImageBackground source={AppIcons.screenBackground} style={styles.mainView}>
      <FastImage source={AppIcons.HeaderBackground} style={styles.headerView}>
        <View style={styles.rowView}>
          <TouchableOpacity
            style={styles.detailsView}
            onPress={() => {
              if (userData?.access_token) {
                navigation.navigate(ROUTE_NAME.EditProfile);
              } else {
                navigation.navigate(ROUTE_NAME.LoginScreen);
              }
              userAction.setTouchSound(true);
            }}
          >
            {userData?.profilePicture != null ? (
              <FastImage
                source={{ uri: userData?.profilePicture }}
                style={styles.userIcon1}
              />
            ) : (
              <FastImage source={AppIcons.UserIcon} style={styles.userIcon} />
            )}

            <View>
              <Text style={styles.t1}>Welcome back</Text>
              <Text style={styles.t2}>
                {truncateText(userData?.name as string, 10) || "Guest"}
              </Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate(ROUTE_NAME.InPurchaseScreen)}
            style={styles.container}
          >
            <Image
              source={AppIcons.Coin}
              style={styles.coin}
              resizeMode={"cover"}
            />
            <View style={styles.countContainer}>
              <Text style={styles.countText}>
                {formatCoins((userData?.coins?.balance as number) || 0)}
              </Text>
            </View>
            <Image source={AppIcons.Plus} style={styles.plusIcon} />
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              userAction.setTouchSound(true);
              setTimeout(() => {
                setShowSettings(true);
              }, 200);
            }}
          >
            <Image source={AppIcons.SettingsIcon} style={styles.settingIcon} />
          </TouchableOpacity>
        </View>
      </FastImage>

      <View style={styles.mainRowView}>
        <TouchableOpacity
          onPress={() => {
            setMusic(!music);
            userAction.setMusicPreference(!music);
            userAction.setPlayMusicPreference(!music);
          }}
        >
          <Image
            source={music ? AppIcons.MusicHome : AppIcons.MuteMusic}
            resizeMode={"contain"}
            style={styles.settingIcon1}
          />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            setSound(!sound);
            userAction.setSoundPreference(!sound);
          }}
        >
          <Image
            source={sound ? AppIcons.SoundHome : AppIcons.MuteSound}
            resizeMode={"contain"}
            style={styles.settingIcon1}
          />
        </TouchableOpacity>
      </View>
      {/* <Spacer size={20} /> */}
      <Image source={AppIcons.Logo} style={styles.logo} />

      <TouchableOpacity
        onPress={() => {
          userAction.setTouchSound(true);
          navigation.navigate(ROUTE_NAME.LuckySpinScreen);
        }}
        style={styles.backIcon}
      >
        <Image
          source={AppIcons.Spinbutton}
          style={{
            width: 120,
            height: 120,
          }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <TouchableOpacity
        style={styles.btn1}
        onPress={() => {
          handlePlayPress(ROUTE_NAME.SelectPlayer, { mode: "friends" });
        }}
      >
        <FastImage
          source={AppIcons.HomeBtn_1}
          style={{ width: "100%", height: "100%" }}
        >
          <Text style={styles.btn1Text}>Pass and{"\n"}Play</Text>
        </FastImage>
      </TouchableOpacity>
      <Spacer />
      <View style={styles.btnView}>
        <TouchableOpacity
          style={styles.btn}
          onPress={() => {
            handlePlayPress(ROUTE_NAME.SelectPlayer, { mode: "computer" });
          }}
        >
          <FastImage
            source={AppIcons.HomeBtn_2}
            style={{ width: "100%", height: "100%" }}
            resizeMode="stretch"
          >
            <Text style={styles.btnText}>Play with{"\n"}Computer</Text>
          </FastImage>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.btn}
          onPress={() => {
            userAction.setTouchSound(true);
            if (!userData?.access_token) {
              Alert.alert("Login", "To play online you need to first login", [
                {
                  text: "Login",
                  onPress: () => {
                    navigation.navigate(ROUTE_NAME.LoginScreen);
                  },
                },
                {
                  text: "Cancel",
                  style: "cancel",
                },
              ]);
              return;
            }
            navigation.navigate(ROUTE_NAME.PlayerRoom);
          }}
        >
          <FastImage
            source={AppIcons.HomeBtn_3}
            style={{ width: "100%", height: "100%" }}
            resizeMode="stretch"
          >
            <Text style={styles.btnText}>Play with{"\n"}Friends</Text>
          </FastImage>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.btn}
          onPress={() => {
            userAction.setTouchSound(true);
            if (!userData?.access_token) {
              Alert.alert("Login", "To play online you need to first login", [
                {
                  text: "Login",
                  onPress: () => {
                    navigation.navigate(ROUTE_NAME.LoginScreen);
                  },
                },
                {
                  text: "Cancel",
                  style: "cancel",
                },
              ]);
              return;
            }
            navigation.navigate(ROUTE_NAME.RandomPlayerRoom);
          }}
        >
          <FastImage
            source={AppIcons.HomeBtn_4}
            style={{ width: "100%", height: "100%" }}
            resizeMode="stretch"
          >
            <Text style={styles.btnText}>Play Online{"\n"}with voice chat</Text>
          </FastImage>
        </TouchableOpacity>
      </View>
      <SettingsModal
        viewType={isdeleted ? "otp" : "settings"}
        visible={showSettings}
        deleteLoading={generateOtpLoading}
        onClose={() => {
          // userAction.setTouchSound(true);
          setShowSettings(false);
          setIsdeleted(false);
        }}
        music={music}
        onMusicChange={() => {
          setMusic(!music);
          userAction.setMusicPreference(!music);
          userAction.setPlayMusicPreference(!music);
          userAction.setTouchSound(true);
        }}
        sound={sound}
        onSoundChange={() => {
          setSound(!sound);
          userAction.setSoundPreference(!sound);
          userAction.setTouchSound(true);
        }}
        notifications={notifications}
        onNotificationsChange={() => {
          setNotifications(!notifications);
          userAction.setTouchSound(true);
        }}
        onPrivacyPress={() => {
          setShowSettings(false);
          userAction.setTouchSound(true);
          setTimeout(() => {
            setPrivacyModal(true);
          }, 200);
        }}
        onTermsPress={() => {
          setShowSettings(false);
          userAction.setTouchSound(true);
          setTimeout(() => {
            setTermsModal(true);
          }, 200);
        }}
        onLogout={() => {
          // userAction.setTouchSound(true);
          confirmLogout();
        }}
        showlogout={userData?.access_token ? true : false}
        onSignIn={() => {
          navigation.navigate(ROUTE_NAME.LoginScreen);
          userAction.setTouchSound(true);
          setShowSettings(false);
        }}
        onOTPSubmit={deleteAccount}
        onIsDeleted={() => {
          userAction.setTouchSound(true);
          deleteAccountRequest();
        }}
      />
      <PrivacyWithTerms
        title={"Terms & Conditions"}
        visible={termsModal}
        url={TERMS_WITH_CONDITIONS}
        onClose={() => {
          userAction.setTouchSound(true);
          setTermsModal(false);
        }}
      />
      <PrivacyWithTerms
        title={"Privacy Policy"}
        visible={privacyModal}
        url={PRIVACY_POLICY}
        onClose={() => {
          userAction.setTouchSound(true);
          setPrivacyModal(false);
        }}
      />
      {/**developer button */}
      <TouchableOpacity
        style={styles.floatBtn}
        onPress={() => {
          if (Platform.OS == "android") {
            Linking.openURL(
              "https://play.google.com/store/apps/details?id=com.thedivine.bible&hl=en_IN",
            );
          } else {
            Linking.openURL(
              "https://apps.apple.com/ae/app/the-divine-bible/id1662497445",
            );
          }
        }}
      >
        <Text style={styles.floatBtnText}>More apps by developer</Text>
        <Image
          source={AppIcons.ARROW_UP}
          style={styles.arrowIcon}
          resizeMode="contain"
        />
      </TouchableOpacity>
    </ImageBackground>
  );
};

export default HomeScreen;

const styles = StyleSheet.create({
  mainView: {
    flex: 1,
  },
  headerView: {
    width: "100%",
    height: Platform.OS === "web" ? 115 : 140,
    paddingTop: Platform.OS === "web" ? 32 : 55,
  },
  rowView: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 10,
  },
  detailsView: {
    flexDirection: "row",
    alignItems: "center",
  },
  userIcon: {
    width: 45,
    height: 45,
    marginRight: 10,
  },
  userIcon1: {
    width: 45,
    height: 45,
    marginRight: 10,
    borderRadius: 30,
    borderColor: AppTheme.colors.modalcolor,
    borderWidth: 1.5,
  },
  mainRowView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
  settingIcon: {
    width: 32,
    height: 32,
  },
  settingIcon1: {
    width: 45,
    height: 45,
  },
  t1: {
    fontSize: 12,
    color: AppTheme.colors.lightGrey,
    fontFamily: AppTheme.fonts.ALEXANDRIA_REGULAR,
  },
  t2: {
    fontSize: 18,
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
  },
  logo: {
    width: 105,
    height: 105,
    resizeMode: "contain",
    alignSelf: "center",
    marginTop: Platform.OS === "web" ? -12 : 0,
    marginBottom: Platform.OS === "web" ? 6 : 0,
  },
  backIcon: {
    position: "absolute",
    right: 0,
    bottom: Platform.OS == "ios" ? 70 : "5%",
    zIndex: 999,
    elevation: 999,
  },
  btn1: {
    width: "95%",
    aspectRatio: Platform.OS === "web" ? 776 / 400 : undefined,
    height:
      Platform.OS === "web"
        ? undefined
        : Platform.OS === "android"
        ? "21%"
        : "22%",
    alignSelf: "center",
    position: "relative",
    marginVertical: Platform.OS === "web" ? 4 : 0,
  },
  btn1Text: {
    position: "absolute",
    right: 25,
    bottom: 25,
    fontSize: Platform.OS === "web" ? 38 : 42,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  btnView: {
    width: "100%",
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingHorizontal: "2.5%",
  },
  btn: {
    width: "32%",
    aspectRatio: Platform.OS === "web" ? 255 / 230 : undefined,
    height: Platform.OS === "web" ? undefined : "43%",
    position: "relative",
  },
  btnText: {
    position: "absolute",
    left: 15,
    bottom: 25,
    fontSize: Platform.OS == "android" ? 14 : 17,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 30,
    // height: 30,
    marginLeft: Platform.OS == "ios" ? 50 : 30,
    backgroundColor: "rgba(0,0,0,0.35)",
    marginRight: Platform.OS == "ios" ? 0 : 10,
  },

  coin: {
    width: 30,
    height: 35,
    marginLeft: -10,
  },

  countContainer: {
    // paddingVertical: 6,
    paddingHorizontal: 15,
    borderRadius: 10,
  },

  countText: {
    color: AppTheme.colors.white,
    fontSize: 18,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
  },
  plusIcon: {
    width: 30,
    height: 30,
    marginRight: -2,
  },
  floatBtn: {
    position: "absolute",
    alignSelf: "center",
    bottom: 10,
    backgroundColor: "#fff5",
    borderRadius: 30,
    paddingHorizontal: 10,
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  floatBtnText: {
    color: AppTheme.colors.white,
    fontSize: 12,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
  },
  arrowIcon: {
    width: 12,
    height: 12,
    marginLeft: 5,
  },
});
